const STORAGE_KEY = 'adaptiv_compare_products';
const LIMIT = 4;

const readItems = () => {
  try {
    const items = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(items) ? items.slice(0, LIMIT) : [];
  } catch (error) {
    return [];
  }
};

const writeItems = (items) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, LIMIT)));
  } catch (error) {
    return;
  }
};

const track = (eventName, payload = {}) => {
  if (window.AdaptivAnalytics?.track) {
    window.AdaptivAnalytics.track(eventName, payload);
  }
};

const buildTray = () => {
  const tray = document.createElement('aside');
  tray.className = 'adaptiv-compare-tray';
  tray.hidden = true;
  tray.setAttribute('aria-live', 'polite');
  tray.innerHTML = `
    <div class="adaptiv-compare-tray__copy">
      <strong data-adaptiv-compare-count>0 saved</strong>
      <span data-adaptiv-compare-label>Save mattresses to compare.</span>
    </div>
    <div class="adaptiv-compare-tray__items" data-adaptiv-compare-items></div>
    <div class="adaptiv-compare-tray__actions">
      <a href="/pages/compare" data-adaptiv-track="compare_tray_open" data-adaptiv-track-location="compare_tray">Compare</a>
      <button type="button" data-adaptiv-compare-clear>Clear</button>
    </div>
  `;
  document.body.append(tray);
  return tray;
};

const ensureStyles = () => {
  if (document.getElementById('adaptiv-compare-tray-styles')) return;

  const style = document.createElement('style');
  style.id = 'adaptiv-compare-tray-styles';
  style.textContent = `
    .adaptiv-compare-tray {
      position: fixed;
      right: 18px;
      bottom: 18px;
      z-index: 30;
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto auto;
      gap: 14px;
      align-items: center;
      width: min(720px, calc(100vw - 36px));
      padding: 14px;
      color: #fff;
      background: #1a1a1a;
      border: 1px solid rgb(212 168 67 / 0.45);
      border-radius: 8px;
      box-shadow: 0 18px 52px rgb(0 0 0 / 0.28);
    }

    .adaptiv-compare-tray[hidden] {
      display: none;
    }

    .adaptiv-compare-tray__copy {
      display: grid;
      gap: 3px;
      min-width: 0;
    }

    .adaptiv-compare-tray__copy strong {
      color: #fff;
      font-size: 0.9rem;
    }

    .adaptiv-compare-tray__copy span,
    .adaptiv-compare-tray__items span {
      color: #c0c0c0;
      font-size: 0.78rem;
      line-height: 1.3;
    }

    .adaptiv-compare-tray__items {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      min-width: 0;
    }

    .adaptiv-compare-tray__items span {
      max-width: 150px;
      padding: 6px 8px;
      overflow: hidden;
      border: 1px solid rgb(255 255 255 / 0.12);
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .adaptiv-compare-tray__actions {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .adaptiv-compare-tray__actions a,
    .adaptiv-compare-tray__actions button {
      display: inline-grid;
      min-height: 38px;
      place-items: center;
      border-radius: 6px;
      font-size: 0.72rem;
      font-weight: 900;
      letter-spacing: 0.08em;
      text-decoration: none;
      text-transform: uppercase;
    }

    .adaptiv-compare-tray__actions a {
      padding: 0 14px;
      color: #1a1a1a;
      background: #d4a843;
    }

    .adaptiv-compare-tray__actions button {
      border: 1px solid rgb(255 255 255 / 0.18);
      padding: 0 12px;
      color: #fff;
      background: #2d2d2d;
      cursor: pointer;
    }

    .adaptiv-card-meta__save {
      width: 100%;
      min-height: 36px;
      border: 1px solid rgb(26 26 26 / 0.14);
      border-radius: 6px;
      color: #1a1a1a;
      background: #fff;
      font-size: 0.72rem;
      font-weight: 900;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      cursor: pointer;
    }

    .adaptiv-card-meta__save[aria-pressed='true'] {
      border-color: rgb(212 168 67 / 0.55);
      background: #d4a843;
    }

    @media screen and (max-width: 720px) {
      .adaptiv-compare-tray {
        right: 10px;
        bottom: calc(86px + env(safe-area-inset-bottom));
        grid-template-columns: 1fr;
        gap: 10px;
        width: calc(100vw - 20px);
        padding: 12px;
      }

      .adaptiv-compare-tray__items {
        flex-wrap: nowrap;
        overflow-x: auto;
        scrollbar-width: none;
      }

      .adaptiv-compare-tray__items::-webkit-scrollbar {
        display: none;
      }

      .adaptiv-compare-tray__items span {
        flex: 0 0 auto;
        max-width: 140px;
      }

      .adaptiv-compare-tray__actions {
        display: grid;
        grid-template-columns: 1fr auto;
      }

      .adaptiv-compare-tray__actions a,
      .adaptiv-compare-tray__actions button {
        min-height: 42px;
      }
    }
  `;
  document.head.append(style);
};

const updateButtons = (items) => {
  const ids = new Set(items.map((item) => item.id));
  document.querySelectorAll('[data-adaptiv-compare-toggle]').forEach((button) => {
    const selected = ids.has(button.dataset.adaptivProductId);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.textContent = selected ? 'Saved to compare' : 'Save compare';
  });
};

const renderTray = (tray, items) => {
  const count = tray.querySelector('[data-adaptiv-compare-count]');
  const label = tray.querySelector('[data-adaptiv-compare-label]');
  const itemList = tray.querySelector('[data-adaptiv-compare-items]');

  tray.hidden = items.length === 0;
  count.textContent = `${items.length} saved`;
  label.textContent = items.length < 2 ? 'Save another model for side-by-side comparison.' : 'Ready for side-by-side comparison.';
  itemList.innerHTML = items.map((item) => `<span>${item.title}</span>`).join('');
  updateButtons(items);
};

const itemFromButton = (button) => ({
  id: button.dataset.adaptivProductId,
  handle: button.dataset.adaptivProductHandle,
  title: button.dataset.adaptivProductTitle,
  type: button.dataset.adaptivProductType,
});

const init = () => {
  ensureStyles();
  const tray = buildTray();
  let items = readItems();
  renderTray(tray, items);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-adaptiv-compare-toggle]');
    if (!button) return;

    const item = itemFromButton(button);
    if (!item.id) return;

    const exists = items.some((saved) => saved.id === item.id);
    items = exists ? items.filter((saved) => saved.id !== item.id) : [item, ...items].slice(0, LIMIT);
    writeItems(items);
    renderTray(tray, items);
    track(exists ? 'compare_remove' : 'compare_save', {
      product_id: item.id,
      product_handle: item.handle,
      product_type: item.type,
      saved_count: items.length,
    });
  });

  tray.querySelector('[data-adaptiv-compare-clear]')?.addEventListener('click', () => {
    items = [];
    writeItems(items);
    renderTray(tray, items);
    track('compare_clear');
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
